import { CanActivateFn } from '@angular/router';

export const subscriptionOnlineGuard: CanActivateFn = () => {
  return navigator.onLine;
};
